var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.93397 8.77881C3.7134 10.5478 6.8167 12.9999 10.3474 12.9999C13.878 12.9999 16.9807 10.5478 18.7601 8.77881C19.2294 8.31226 19.4649 8.07819 19.6143 7.62012C19.7209 7.29328 19.7209 6.70674 19.6143 6.3799C19.4649 5.92181 19.2295 5.6877 18.7601 5.22111C16.9807 3.45208 13.878 1 10.3474 1C6.8167 1 3.7134 3.45208 1.93397 5.22111C1.46431 5.68802 1.22945 5.92165 1.07996 6.3799C0.973345 6.70673 0.973345 7.29328 1.07996 7.62012C1.22945 8.07837 1.4643 8.31189 1.93397 8.77881Z",
    stroke: "#0075FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34717 7C8.34717 8.10457 9.2426 9 10.3472 9C11.4517 9 12.3472 8.10457 12.3472 7C12.3472 5.89543 11.4517 5 10.3472 5C9.2426 5 8.34717 5.89543 8.34717 7Z",
    stroke: "#0075FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.a995db316016343fdf238bd246a1d0e1.svg";
export { ForwardRef as ReactComponent };